import React from "react";
import { observer } from "mobx-react-lite";
import {
	Box,
	ButtonPrimary,
	IconAutenticationSuccessRegular,
	skinVars,
	Text3,
	Text6,
	BoxedRow,
	Circle,
	IconGiftRegular,
	IconWalletRegular,
	IconPayInvoiceRegular,
	Image,
	ResponsiveLayout,
	Grid,
	useScreenSize,
	IconCalendarRegular,
} from "@telefonica/mistica";
import { default as VivoLogo } from "../../assets/icons/VivoLogo.svg";
import ImageMobile from "../../assets/images/contract-condictions-banner-mobile.png";
import ImageDesktop from "../../assets/images/contract-condictions-banner-desktop.png";
import { strings } from "../../localization";
import Banner from "../Banner";

interface IProps {
	handleOnPress: VoidFunction;
}

export const ContractConditions: React.FC<IProps> = observer((props: IProps) => {
	const { cards, title, buttonAnticipate } = strings.components.contractConditions;
	const { isDesktopOrBigger } = useScreenSize();
	const { handleOnPress } = props;

	return (
		<ResponsiveLayout className="font-family-vivotype">
			<Box paddingTop={isDesktopOrBigger ? 80 : 56}>
				<Banner
					desktopImg={ImageDesktop}
					mobileImg={ImageMobile}
					info={{
						heading: {children: isDesktopOrBigger ? "" : title},
					}}
					height="340px"
					bgPosition={{ base: "right center", lg: "right top" }}
				/>
				<Box paddingY={40} className="display-none-mobile">
					<Grid columns={{ maxSize: 600 }}>
						<Text6>{title}</Text6>
					</Grid>
				</Box>
				<Box className="mini-card-grid" paddingTop={isDesktopOrBigger ? 0 : 32} >
					<Grid gap={isDesktopOrBigger ? 24 : 16} columns={isDesktopOrBigger ? 3 : 1}>
						<BoxedRow
							asset={
								<Circle size={40} backgroundColor={skinVars.colors.brandLow}>
									<IconAutenticationSuccessRegular size={24} color={skinVars.colors.brand} />
								</Circle>
							}
							title={cards[0].title}
						/>
						<BoxedRow
							asset={
								<Circle size={40} backgroundColor={skinVars.colors.brandLow}>
									<IconGiftRegular size={24} color={skinVars.colors.brand} />
								</Circle>
							}
							title={cards[1].title}
						/>
						<BoxedRow
							asset={
								<Circle size={40} backgroundColor={skinVars.colors.brandLow}>
									<IconWalletRegular size={24} color={skinVars.colors.brand} />
								</Circle>
							}
							title={cards[2].title}
						/>
						<BoxedRow
							asset={
								<Circle size={40} backgroundColor={skinVars.colors.brandLow}>
									<IconPayInvoiceRegular size={24} color={skinVars.colors.brand} />
								</Circle>
							}
							title={cards[3].title}
						/>
						<BoxedRow
							asset={
								<Circle size={40} backgroundColor={skinVars.colors.brandLow}>
									<Image src={VivoLogo} height={24} width={24} />
								</Circle>
							}
							title={cards[4].title}
						/>
						<BoxedRow
							asset={
								<Circle size={40} backgroundColor={skinVars.colors.brandLow}>
									<IconCalendarRegular size={24} color={skinVars.colors.brand} />
								</Circle>
							}
							title={cards[5].title}
						/>
					</Grid>
				</Box>
				<Box paddingTop={32} paddingBottom={isDesktopOrBigger ? 80 : 56}>
					<ButtonPrimary style={{ borderRadius: "999px" }}  onPress={handleOnPress}>
						<Text3 medium color={skinVars.colors.textButtonPrimary}>
							{buttonAnticipate}
						</Text3>
					</ButtonPrimary>
				</Box>
			</Box>
		</ResponsiveLayout>
	);
});
